export default "__VITE_ASSET__De$Pzvq1__"